import { alpha } from "@theme-ui/color";
import { Theme } from "theme-ui";

export const buttons: Required<Theme>["buttons"] = {
  primary: {
    label: "primary",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    transition: ".1s linear background-color, .2s linear box-shadow",
    color: "text.default",
    borderRadius: 200,
    cursor: "pointer",
    backgroundColor: "fill.default",
    borderWidth: "4px",
    borderColor: "transparent",
    borderStyle: "solid",
    ":hover:enabled": {
      backgroundColor: "hover.brand"
    },
    ":hover": {
      backgroundColor: "hover.brand"
    },
    ":focus:enabled": {
      outline: "none",
      borderColor: "focus.default"
    },
    ":disabled": {
      cursor: "unset",
      opacity: 0.4
    }
  },
  secondary: {
    label: "secondary",
    variant: "buttons.primary",
    backgroundColor: "fill.muted",
    ":hover:enabled, :hover": {
      backgroundColor: "hover.muted"
    },
    ":disabled": {
      cursor: "unset",
      backgroundColor: "fill.muted",
      opacity: 0.4
    }
  },
  tertiary: {
    label: "tertiary",
    variant: "buttons.primary",
    backgroundColor: "fill.subtle",
    ":hover:enabled,:hover": {
      backgroundColor: "hover.default"
    },
    ":hover:disabled": {
      backgroundColor: "fill.subtle"
    },
    ":disabled": {
      cursor: "unset",
      backgroundColor: alpha("fill.subtle", 0.3),
      opacity: 0.8
    }
  },
  destructive: {
    label: "destructive",
    variant: "buttons.primary",
    backgroundColor: "fill.error",
    borderColor: "transparent",
    ":hover:enabled,:hover": {
      backgroundColor: "hover.error",
      backgroudOpacity: 0.9
    },
    ":hover:disabled": {
      backgroundColor: "fill.error"
    },
    ":disabled": {
      cursor: "unset",
      backgroundColor: alpha("fill.error", 0.3),
      color: alpha("text.highlight", 0.3)
    }
  },
  large: {
    minWidth: 120,
    height: 56,
    padding: "0 22px"
  },
  medium: {
    variant: "buttons.large",
    height: 48
  },
  small: {
    variant: "buttons.large",
    lineHeight: 0,
    minWidth: 0,
    padding: "0 16px",
    height: 36
  },
  mini: {
    variant: "buttons.large",
    lineHeight: 0,
    minWidth: 0,
    padding: "0 4px",
    height: 28,
    borderWidth: "2px"
  },
  icon: {
    variant: "buttons.tertiary",
    width: 36,
    height: 36,
    padding: 0,
    ":hover:enabled, :hover": {
      backgroundColor: "hover.subtle"
    },
    ":disabled": {
      cursor: "unset",
      opacity: 0.3
    }
  }
};
